import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';

import { List, Map, fromJS } from 'immutable';
import { Icon, Dropdown, Dimmer, Progress, Image } from 'semantic-ui-react';
import { TextField, Tooltip, IconButton } from 'material-ui';

import { targetEmailAsyncValidate } from 'libs/validation';
import Scrollbar from 'libs/Scrollbar';
import * as common from 'libs/commonFunc';
import * as commonVar from 'libs/commonVar';

import { DetailTemplate, MaterialSnackbar, ModalDeclarePut, ModalDeclareDelete } from 'components';

import styles from './Declare.css';
import classNames from 'classnames/bind';
const cx = classNames.bind(styles);

class DeclareDetail extends Component {
  constructor(props) {
    super(props);
  }

  // 대상자 신고 상세 항목별 존재여부 체크
  checkDetailData = (data, type) => {
    const value = data[type];

    if (data && value) {
      if (type === 'declareType') {
        return value === 'spam' ? '스팸' : '해킹';
      } else if (type === 'declareEpoch') {
        return common.timeFormatFromUTCEpoch(value);
      } else {
        return value;
      }
    } else {
      return '-';
    }
  };

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const {
      selectDeclareNo,
      isSnackbar,
      onPutDeclare,
      onDeleteDeclare,
      onToggleModal,
      isModal,
      // function
      onToggleSnackbar,
      onToggleDetailView,
      onToggleModalDeclare,
      onMoveScroll,
      onRefRegister,
      currentPath
    } = this.props;
    // 상세 정보
    const { declareDetail, declareDetailOrdering, selectDeclareTargetNo } = this.props;
    const { checkDetailData } = this;

    // 데이터가 없는 경우
    let isNoData = true;
    if (selectDeclareTargetNo > 0 && declareDetail.size > 0) {
      isNoData = false;
    }

    // 신고 상세 정보 리스트
    const declareListComponent =
      !isNoData &&
      declareDetailOrdering.map((declareNo, index) => {
        const data = declareDetail.get(String(declareNo));
        if (!!data) {
          // declareFlag - 1: 훈련신고, 2: 외부신고
          const isExternal = data.declareFlag === 2;
          return (
            <div key={index} className={cx('declare-detail')}>
              <div className={cx('detail-box', 'pt-30')}>
                <div className={cx('detail-box-list')}>
                  <span className={cx('detail-title')}>·&nbsp;&nbsp;No</span>
                  <span className={cx('detail-content')}>{checkDetailData(data, 'declareNo')}</span>
                </div>

                {!isExternal && <div className={cx('detail-box-list')}>
                  <span className={cx('detail-title')}>
                    ·&nbsp;&nbsp;{defineMessages(formatMessage({ id: 'ModalDeclare_5', defaultMessage: '훈련명' }))}
                  </span>
                  <span className={cx('detail-content')}>{checkDetailData(data, 'examName')}</span>
                </div>}
                {!isExternal && <div className={cx('detail-box-list')}>
                  <span className={cx('detail-title')}>
                    ·&nbsp;&nbsp;{defineMessages(formatMessage({ id: 'ModalDeclare_8', defaultMessage: '템플릿명' }))}
                  </span>
                  <span className={cx('detail-content')}>{checkDetailData(data, 'templateName')}</span>
                </div>}

                {isExternal && <div className={cx('detail-box-list')}>
                  <span className={cx('detail-title')}>
                    ·&nbsp;&nbsp;{defineMessages(formatMessage({ id: 'ModalDeclare_15', defaultMessage: '메일 제목' }))}
                  </span>
                  <span className={cx('detail-content')}>{checkDetailData(data, 'mailSubject')}</span>
                </div>}

                <div className={cx('detail-box-list')}>
                  <span className={cx('detail-title')}>
                    ·&nbsp;&nbsp;{defineMessages(formatMessage({ id: 'ModalDeclare_6', defaultMessage: '신고 제목' }))}
                  </span>
                  <span className={cx('detail-content')}>{checkDetailData(data, 'subject')}</span>
                </div>
                <div className={cx('detail-box-list')}>
                  <span className={cx('detail-title')}>
                    ·&nbsp;&nbsp;{defineMessages(formatMessage({ id: 'ModalDeclare_9', defaultMessage: '메일 신고 내용' }))}
                  </span>
                  <span className={cx('detail-content')}>{checkDetailData(data, 'content')}</span>
                </div>

                {isExternal && <div className={cx('detail-box-list')}>
                  <span className={cx('detail-title')}>
                    ·&nbsp;&nbsp;{defineMessages(formatMessage({ id: 'ModalDeclare_16', defaultMessage: '메일 신고 유형' }))}
                  </span>
                  <span className={cx('detail-content')}>{checkDetailData(data, 'declareType')}</span>
                </div>}

                {data.isNis !== 1 && (
                  <div className={cx('pt-12')}>
                    <div className={cx('detail-box-list')}>
                      <span className={cx('detail-title')}>
                        ·&nbsp;&nbsp;{defineMessages(
                          formatMessage({ id: 'ModalDeclare_12', defaultMessage: '신고자 이름' })
                        )}
                      </span>
                      <span className={cx('detail-content')}>{data.extraInfo && checkDetailData(data.extraInfo, 'declareName')}</span>
                    </div>
                    <div className={cx('detail-box-list')}>
                      <span className={cx('detail-title')}>
                        ·&nbsp;&nbsp;{defineMessages(
                          formatMessage({ id: 'ModalDeclare_14', defaultMessage: '신고자 이메일' })
                        )}
                      </span>
                      <span className={cx('detail-content')}>{data.extraInfo && checkDetailData(data.extraInfo, 'declareEmail')}</span>
                    </div>

                    {/* 훈련탭 상세보기 */}
                    <div className={cx('detail-box-list')}>
                      <span className={cx('detail-title')}>
                        ·&nbsp;&nbsp;{defineMessages(
                          formatMessage({ id: 'ModalDeclare_13', defaultMessage: '신고자 소속' })
                        )}
                      </span>
                      <span className={cx('detail-content')}>{data.extraInfo && checkDetailData(data.extraInfo, 'declareDivision')}</span>
                    </div>
                    <div className={cx('detail-box-list')}>
                      <span className={cx('detail-title')}>
                        ·&nbsp;&nbsp;{defineMessages(formatMessage({ id: 'ModalDeclare_7', defaultMessage: '신고 일시' }))}
                      </span>
                      <span className={cx('detail-content')}>{checkDetailData(data, 'declareEpoch')}</span>
                    </div>

                    {isExternal && <div className={cx('detail-box-list')}>
                      <span className={cx('detail-title')}>
                        ·&nbsp;&nbsp;{defineMessages(formatMessage({ id: 'ModalDeclare_17', defaultMessage: '발신지 도시' }))}
                      </span>
                      <span className={cx('detail-content')}>{checkDetailData(data, 'countyName')}</span>
                    </div>}
                    {isExternal && <div className={cx('detail-box-list')}>
                      <span className={cx('detail-title')}>
                        ·&nbsp;&nbsp;{defineMessages(formatMessage({ id: 'ModalDeclare_18', defaultMessage: '발신지 IP' }))}
                      </span>
                      <span className={cx('detail-content')}>{checkDetailData(data, 'ip')}</span>
                    </div>}
                  </div>
                )}
                
                <div className={cx('detail-list-title-wrap')}>
                  <div className={cx('detail-list-title')}>
                    {data.isNis === 1 && (
                      <div className={cx('detail-label nis')}>
                        {defineMessages(formatMessage({ id: 'Declare_9', defaultMessage: '국정원 신고' }))}
                      </div>
                    )}
                    {isExternal && (
                      <div className={cx('detail-label external')}>
                        {defineMessages(formatMessage({ id: 'Declare_17', defaultMessage: '외부 신고' }))}
                      </div>
                    )}
                    {data.isNis !== 1 && !isExternal && (
                      <div className={cx('detail-label normal')}>
                        {defineMessages(formatMessage({ id: 'Declare_16', defaultMessage: '훈련 신고' }))}
                      </div>
                    )}
                    <div className={cx('declare-detail-edit-wrap')}>
                      <div className={cx('declare-detail-edit')}>
                        {data.isNis !== 1 && !isExternal && (
                          <div
                            className={cx('editIcon')}
                            onClick={e => {
                              e.stopPropagation();
                              onToggleModalDeclare(data.declareNo, 'put');
                            }}
                            title={defineMessages(
                              formatMessage({ id: 'TargetDetail_1', defaultMessage: '편집하려면 클릭하세요' })
                            )}>
                            <Icon name="pencil" />
                          </div>
                        )}
                        {!isExternal &&
                          <div
                            className={cx('editIcon')}
                            onClick={e => {
                              e.stopPropagation();
                              onToggleModalDeclare(data.declareNo, 'delete');
                            }}
                            title={defineMessages(
                              formatMessage({ id: 'ModalDeclare_11', defaultMessage: '신고 이력 삭제 하기' })
                            )}>
                            <Icon name="trash" />
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        }
      });

    return (
      <DetailTemplate onMoveScroll={onMoveScroll} onToggleDetailView={onToggleDetailView}>
        <MaterialSnackbar isSnackbar={isSnackbar} onToggleSnackbar={onToggleSnackbar} />
        {/* ------------------------------------- 데이터가 없을 경우 ------------------------------------ */}
        {!!isNoData && (
          <Dimmer active inverted className={cx('isNoData')}>
            <div className={cx('isNoData-content')}>
              {/* <Icon name="pointing up" /> */}
              <Image className={cx('mr-5 info-select-icon')} src="/img/exam/info_select.png" />
              <div className={cx('text')}>
                {defineMessages(formatMessage({ id: 'TargetDetail_19', defaultMessage: '대상자를 선택하세요.' }))}
              </div>
            </div>
          </Dimmer>
        )}
        {/* 신고 상세 수정 모달 */}
        {isModal === 'declarePut' && (
          <ModalDeclarePut
            visible
            selectDeclareNo={selectDeclareNo}
            declareDetail={declareDetail}
            onPutDeclare={onPutDeclare}
            onToggleModal={onToggleModal}
          />
        )}
        {/* 신고 상세 삭제 모달 */}
        {isModal === 'declareDelete' && (
          <ModalDeclareDelete
            visible
            selectDeclareNo={selectDeclareNo}
            declareDetail={declareDetail}
            onDeleteDeclare={onDeleteDeclare}
            onToggleModal={onToggleModal}
          />
        )}
        <Scrollbar
          ref={Scroll => {
            onRefRegister('scroll', Scroll);
          }}>
          <div className={cx('element-wrapper')}>
            <div className={cx('declare-detail-wrapper')}>
              <div className={cx('exam-title')}>
                {defineMessages(formatMessage({ id: 'Declare_11', defaultMessage: '신고 정보' }))}
              </div>
              {/* 신고 상세 리스트 */}
              {!!!isNoData && declareListComponent}
            </div>
          </div>
        </Scrollbar>
      </DetailTemplate>
    );
  }
}

DeclareDetail.propTypes = {
  onToggleModal: PropTypes.func
};

const mapStateToProps = (state, { isEditType, isEditData }) => {
  return {
    initialValues: {
      targetName: isEditType === 'targetName' && isEditData.get('targetName'),
      targetEmail: isEditType === 'targetEmail' && isEditData.get('targetEmail'),
      targetPhone: isEditType === 'targetPhone' && isEditData.get('targetPhone'),
      targetDivision: isEditType === 'targetDivision' && isEditData.get('targetDivision'),
      targetPosition: isEditType === 'targetPosition' && isEditData.get('targetPosition'),
      targetTag: isEditType === 'targetTag' && isEditData.get('targetTag'),
      targetDetail: isEditType === 'targetDetail' && isEditData.get('targetDetail')
    }
  };
};

export default connect(mapStateToProps)(
  reduxForm({
    form: 'formTargetEdit',
    enableReinitialize: true,
    asyncValidate: targetEmailAsyncValidate,
    asyncBlurFields: ['targetEmail'],
    destroyOnUnmount: false,
    touchOnChange: true // validation 안내를 적절한 시점에 보이기 위해 반드시 필요함
  })(injectIntl(DeclareDetail))
);



// WEBPACK FOOTER //
// ./src/script/components/declare/DeclareDetail.js